import React from 'react';
import DestimeStatsCards from './DestimeStatsCards';
import DestimeTrendCard from './DestimeTrendCard';
import DestimeTopActionsCard from './DestimeTopActionsCard';

const OverviewDestimeSection = ({
  destimeStats,
  formatDuration,
  destimeTrendMode,
  setDestimeTrendMode,
  destimeTrendYear,
  setDestimeTrendYear,
  destimeAvailableYears,
  destimeWeeklyTabs,
  destimeTrendWeekIndex,
  setDestimeTrendWeekIndex,
  destimeMonthlyTrendData,
  destimeWeeklyTrendData,
  destimeTopActions,
}) => {
  return (
    <div className="space-y-6 md:space-y-8">
      <DestimeStatsCards destimeStats={destimeStats} formatDuration={formatDuration} />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
        <DestimeTrendCard
          destimeTrendMode={destimeTrendMode}
          setDestimeTrendMode={setDestimeTrendMode}
          destimeTrendYear={destimeTrendYear}
          setDestimeTrendYear={setDestimeTrendYear}
          destimeAvailableYears={destimeAvailableYears}
          destimeWeeklyTabs={destimeWeeklyTabs}
          destimeTrendWeekIndex={destimeTrendWeekIndex}
          setDestimeTrendWeekIndex={setDestimeTrendWeekIndex}
          destimeMonthlyTrendData={destimeMonthlyTrendData}
          destimeWeeklyTrendData={destimeWeeklyTrendData}
        />

        <DestimeTopActionsCard destimeTopActions={destimeTopActions} formatDuration={formatDuration} />
      </div>
    </div>
  );
};

export default OverviewDestimeSection;
